import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { CategoryService } from '../../../services/category.service';
import { Category } from 'src/app/models/category/category.module';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
declare var $: any;
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';
registerLocaleData(localeEs, 'es-Mx');
import { HttpClient, HttpEventType } from '@angular/common/http';
import { NewTask } from '../../../models/tarea/tarea.module';
import { TareasService } from '../../../services/tareas.service';
import { FileItem } from '../../../models/adduser/adduser/adduser.module';
import { DatepicketLocalizationService, I18n } from '../../../services/datepicket-localization-service.service';
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-agregar',
  templateUrl: './agregar.component.html',
  styleUrls: ['./agregar.component.css'],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: DatepicketLocalizationService }
  ],
})


export class AgregarComponent implements OnInit {

  @Output() cerrarFormulario: EventEmitter<any>;
  @Output() otrafuncion = new EventEmitter<any>();

  activ;
  token;
  listas;
  loading: boolean = false;
  aform: boolean = false;
  tipo_fecha: boolean = false;
  aestatus: boolean = false;
  model: NgbDateStruct;
  model2: NgbDateStruct;
  time = { hour: 13, minute: 30 };
  time2 = { hour: 13, minute: 30 };
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  task: NewTask;
  archivos: FileItem[] = [];
  mensaje_error: string;
  public options: Object = {
    placeholderText: 'Escribe un comentario',
    charCounterCount: false
  }
  @Input() cat: any;
  @Input() proyecto_actividad: any;
  constructor(private _userService: UserService, private _categoryService: CategoryService, public router: Router,
    private calendar: NgbCalendar, public formatter: NgbDateParserFormatter, private _tareasService: TareasService) {
    this.fromDate = calendar.getToday();
    this.cerrarFormulario = new EventEmitter();
    this.otrafuncion = new EventEmitter();

    //this.cat = _categoryService.category;
    //this.proyecto_actividad = _categoryService.activ;
    const token = this._userService.getToken();
    this.token = token;
    const user = this._userService.getIdentity();
  }


  ngOnInit(): void {
    $('select').selectpicker();
    setTimeout(() => {
      $('select').selectpicker('refresh');
    }, 1500);
  }
  ngOnChanges(): void {
    // console.log(this.proyecto_actividad);
    // console.log(this.cat);
    this.task = new NewTask(this.proyecto_actividad, "", 0, "", "", "", "", "", 0, 0, false, [], "#007bff");
    this.usuarios_estatus(this.cat);
  }
  usuarios_estatus(cat) {
    this._tareasService.taskformAdd(cat, this.token).subscribe(
      response => {
        this.listas = response;
        //console.log(response);
      },
      error => {
        console.log(error);
      }
    );
  }
  cerrar() {
    this.cerrarFormulario.emit();
  }
  fecha_uno() {
    this.tipo_fecha = false;
  }
  fecha_dos() {
    this.tipo_fecha = true;
  }


  onSubmit(form) {
    this.loading = true;
    this.task.comentario = form.value.comentario;
    if (this.task.tipo == 0) {
      const date = this.model.year + '-' + this.model.month + '-' + this.model.day;
      const hora1 = this.time.hour + ':' + this.time.minute + ':00';
      const hora2 = this.time2.hour + ':' + this.time2.minute + ':00';
      const fecha = date + '  ' + hora1;
      const fecha2 = date + '  ' + hora2;
      this.task.fecha_inicio = fecha;
      this.task.fecha_termino = fecha2;
    } else {
      const fecha = this.model.year + '-' + this.model.month + '-' + this.model.day + ' 00:00:00';
      const fecha2 = this.model2.year + '-' + this.model2.month + '-' + this.model2.day + ' 00:00:00';
      this.task.fecha_inicio = fecha;
      this.task.fecha_termino = fecha2;
    }
    //console.log(this.task);
    this._tareasService.taskAdd(this.task, this.token).subscribe(
      response => {
        this.otrafuncion.emit();
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Se guardo correctamente',
          showConfirmButton: false,
          timer: 1500
        });
        this.task = new NewTask(this.proyecto_actividad, "", 0, "", "", "", "", "", 0, 0, false, [], "#007bff");
        this.loading = false;
        this.otrafuncion.emit();
        console.log(response);
        console.log("se actualia");

      },
      error => {
        console.log("ocurrio un error");
        console.log(error);
        this.loading = false;
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          }, error => {
            console.log(error);
          }
        );
      }
    );
  }

  campo_estatus() {
    this.aestatus = true;
  }
  cerrar_campo_estatus() {
    this.aestatus = false;
  }
}
